const URL = process.env.NODE_ENV === 'production' ? '/appapi' : '/api';
export const BaseURL =
    process.env.NODE_ENV === "production" ? "https://www.hjd999.com" : "https://www.hjd999.com";
export default URL;